import CargosService from "@/services/cxc/CargosService";
import TipoCargoService from "@/services/cxc/TipoCargoService";
import CargoSerieService from "@/services/cxc/CargoSerieService";
import SerieCargoService from "@/services/cxc/SerieCargoService";
import CajaService from "@/services/cxc/CajaService";

const fetch = (context, params) => {
  return CargosService.fetch(params)
    .then(res => {
      context.commit('CARGOS', res.data);
    });
};

const setFilter = (context, params) => {
  context.commit('FILTERS', res.data);
  return CargosService.fetch(params)
    .then(res => {
    });
};

const tipocargo = (context, params) => {
  return TipoCargoService.fetch(params)
    .then(res => {
      context.commit('TIPOCARGO', res.data);
    });
};

const cargos = (context, params) => {
  return CargosService.fetch(params)
    .then(res => {
      context.commit('CARGOS', res.data);
    });
};

const series = (context, params) => {
  return SerieCargoService.fetch(params)
    .then(res => {
      context.commit('SERIES', res.data);
    });
};

const caja = (context, params) => {
  return CajaService.fetch(params)
    .then(res => {
      context.commit('CAJA', res.data);
    });
};




export default {
  fetch,
  tipocargo,
  cargos,
  series,
  setFilter,
  caja,
};